import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {Uuid} from "../interface/response/uuid";
import {first, take} from "rxjs/operators";
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {DOCUMENT} from "@angular/common";
import {AddressImport} from "../interface/address-import";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";

@Injectable({
  providedIn: 'root'
})
export class AddressImportService {
  public readonly importListSubject: ReplaySubject<CountedAndPaginated<AddressImport>>
    = new ReplaySubject<CountedAndPaginated<AddressImport>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  public import(formData: object): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/address/method/import`, formData)
      .pipe(
        take(1)
      ) as Observable<Uuid>;
  }

  public getImport(importId: string): Observable<AddressImport> {
    return this.httpClient.get(`/rest/crm/address-import/${importId}`)
      .pipe(first()) as Observable<AddressImport>;
  }

  public loadImportList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm/address-import?page=${page + 1}&pageSize=${pageSize}&`
      + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<AddressImport>) => {
        this.importListSubject.next(result);
      });
  }

  public delete(uuid: string): Observable<any> {
    return this.httpClient.delete(`/rest/crm/address-import/${uuid}`)
      .pipe(first());
  }

}
